"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUSTRALIA_DEMOGRAPHICS = exports.GEO = void 0;
var question_1 = require("../../utils/question");
var types_1 = require("../types");
var common_1 = require("./common");
var GEO = function (t, languages, settings) {
    var value = types_1.DYNATA_QVALUE.GEO_AU;
    var translateKey = types_1.DYNATA_TRANSLATION_KEYS[value];
    var options = [
        { value: '21400191', label: 'Tasmania' },
        { value: '21400192', label: 'South Australia' },
        { value: '21400193', label: 'Victoria' },
        { value: '21400195', label: 'Queensland' },
        { value: '21400196', label: 'New South Wales' },
        { value: '21400198', label: 'Northern Territory' },
        { value: '21400199', label: 'Australian Capital Territory' },
        { value: '21400201', label: 'Western Australia' },
        { value: '21400202', label: 'Jervis Bay Territory' },
        { value: '24219834', label: 'Cocos (Keeling) Islands' },
        { value: '24219835', label: 'Christmas Island' },
        { value: '24219836', label: 'Norfolk Island' },
        { value: '24219837', label: 'Heard & McDonald Islands' }
    ];
    return __assign(__assign({}, (0, common_1.getDefaultQuestion)(t, languages, translateKey, 'GEO - Australia State', value, t && !!(settings === null || settings === void 0 ? void 0 : settings.questionTexts), { geo: 'state' })), { options: (0, question_1.getBuiltInOptions)(languages, options, t, translateKey, settings === null || settings === void 0 ? void 0 : settings.options, settings === null || settings === void 0 ? void 0 : settings.questionId) });
};
exports.GEO = GEO;
var AUSTRALIA_DEMOGRAPHICS = function (t, languages, settings) { return [
    (0, common_1.GENDER)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.AGE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.PERSONAL_CARE_PRODUCTS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.LANGUAGE_FLUENCY)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.FINANCIAL_PRODUCT)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, exports.GEO)(t, languages, settings),
    (0, common_1.HOUSEHOLD_CHILDREN)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.VEHICLES_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.HOUSEHOLD_APPLICANCE_OWNED)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.EMPLOYMENT_STATUS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.PETS_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.ENGINE_TYPE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.NUMBER_OF_CHILDREN)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.NON_ALCOHOLIC_BEVERAGES)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.HOME_TYPE)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.SEXUAL_ORIENTATION)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.NUMBER_PPL_IN_HOUSEHOLD)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.HOUSEHOLD_GROSS_INCOME)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.RACE_ETHNICITY)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.MARTIAL_STATUS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.HOUSEHOLD_INVESTABLE_ASSETS)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.EDUCATION)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings),
    (0, common_1.PRIMARY_VEHICLES)(t, languages, types_1.SUPPORTED_COUNTRY_ISO.AU, settings)
]; };
exports.AUSTRALIA_DEMOGRAPHICS = AUSTRALIA_DEMOGRAPHICS;
//# sourceMappingURL=AU.js.map